import { render, staticRenderFns } from "./WarehouseCreateView.vue?vue&type=template&id=13813ff0"
import script from "./WarehouseCreateView.vue?vue&type=script&lang=js"
export * from "./WarehouseCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports